<template>
<div>
    <div class="pgemnt-1">
        <div class="tbs">
            <el-table :data="showArr" style="width: 100%" border v-loading="loading" row-key="id" default-expand-all :tree-props="{ children: 'dtos', hasChildren: 'hasChildren' }">
                <el-table-column label="栏目名称" prop="name"> </el-table-column>
                <el-table-column label="排序" prop="weight" width="180">
                </el-table-column>
                <el-table-column align="left" width="280" label="操作">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="addColumn('child', scope.row)" size="mini">添加子栏目</el-button>
                        <el-button type="warning" @click="addColumn('edit', scope.row)" size="mini">编辑</el-button>
                        <el-button type="danger" @click="delColumn(scope.row.id)" size="mini">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</div>
</template>

<script>
import {
    getColumnTree,
    delColumn
} from '@/api/jingshi';
import JuirsBtn from '@/views/components/Jurisdiction/jurs_btn';
export default {
    components: {
        JuirsBtn
    },
    data() {
        return {
            loading: false,
            showArr: [],
        }
    },
    methods: {
        // 添加子栏目
        addColumn(type, row) {
            var querys = {};
            if (type == 'new') {
                querys.level = 1;
            }
            if (type == 'child') {
                querys.level = row.level + 1;
                querys.parentId = row.id;
            }
            if (type == 'edit') {
                querys.level = row.level;
                querys.id = row.id;
            }
            this.$router.push({
                path: '/column/add_column',
                query: querys
            });
        },
        // 删除
        delColumn(id) {
            var param = {
                ids: [id]
            };
            delColumn(param).then(res => {
                this.getList();
                this.$message.success('操作成功！');
            }).catch(err => {
                console.log(err)
                // this.$message.error('保存失败!')
            });
        },
        // 获取栏目数据
        getList() {
            var vues = this;
            this.loading = true;
            getColumnTree().then(res => {
                vues.loading = false;
                vues.showArr = res.cmsColumnLists;
                // console.log(res);
                // console.log(vues.showArr);
            })
        }
    },
    created: function () {
        this.getList();
    }
}
</script>

<style lang="scss">
.pgemnt-1 {
    padding: 20px;
}

.pgemnt-1-dag table {
    width: 100%;
    margin-top: 12px;
}

.pgemnt-1 .newAdd {
    width: 90px;
}

.el-table thead {
    color: #666;
    font-weight: 400;
}

// 头部样式
.tbs th {
    background-color: #efefef;
}
</style>



// WEBPACK FOOTER //
// column.vue?78523f8e